// extracted by mini-css-extract-plugin
export default {"actionButtons":"TableList_actionButtons__C-7k6","label":"TableList_label__cVLYE","tableList":"TableList_tableList__4CjhJ"};